import React from "react";
import { styled } from "@mui/system";
import { useIntl } from "react-intl";
import HitComps from "./HitComps";
import { Typography } from "@mui/material";

const ULHits = styled('ul')({
	margin: "12px 0px",
	padding: "0",
})

const TypoEmpty = styled(Typography)({
  width: '90%',
	margin: '12px auto',
})

const CustomHitsBox = ({hits, handleClick}) => {
  const intl = useIntl()

  return (
		<>
			{hits.length === 0
			&& 
				<TypoEmpty>
					{intl.formatMessage({ id: "searchEmpty" })}
				</TypoEmpty>
			}
			{hits.length !== 0
			&&
			<ULHits role="listbox" aria-label="result">
				{hits.map((hit, i) => {
					if (hit.translations.find((trans) => (trans.lang === intl.locale)).title !== ""){
						return (
							<React.Fragment key={hit.id + " " + i}>
								{hit.translations.find((trans) => (trans.lang === intl.locale)).title !== "" && <HitComps hit={hit} handleClick={handleClick}/>}
							</React.Fragment>
						)
					} else {
						return (
							<React.Fragment key={hit.id}></React.Fragment>
						)
					}
				})}
			</ULHits>
			}
		</>
  )
}

export default CustomHitsBox